var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tooltip, classes: 'tooltip-wide' }),expression:"{ content: tooltip, classes: 'tooltip-wide' }"}],staticClass:"capacity__ad text-center",class:_vm.className},[_vm._v("\n    "+_vm._s(_vm.usedCapacity)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }